import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["level"],
    _excluded2 = ["size"],
    _excluded3 = ["size"],
    _excluded4 = ["size"];
import React from "react";
import { Heading as _Heading, Box } from "@chakra-ui/core";
import { jsx as ___EmotionJSX } from "@emotion/react";
var headingSizes = [{}, {
  as: "h1",
  fontSize: "3xl"
}, {
  as: "h2",
  fontSize: "2xl"
}, {
  as: "h3",
  fontSize: "xl"
}, {
  as: "h4",
  fontSize: "lg"
}, {
  as: "h5",
  fontSize: "md"
}, {
  as: "h6",
  fontSize: "sm"
}];
export var Heading = function Heading(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 3 : _ref$level,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var hProps = headingSizes[level];
  return ___EmotionJSX(_Heading, _extends({}, hProps, {
    color: "gray.900",
    lineHeight: 1.2
  }, props));
};
export var Label = function Label(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "xs" : _ref2$size,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return ___EmotionJSX(Box, _extends({
    fontSize: size,
    fontWeight: "bold",
    color: "gray.900",
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    as: "div",
    lineHeight: 1.2
  }, props));
};
export var Subheading = function Subheading(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? "md" : _ref3$size,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  return ___EmotionJSX(Box, _extends({
    fontSize: size,
    fontWeight: "normal",
    color: "gray.700",
    as: "p",
    lineHeight: 1.2
  }, props));
};
export var Caption = function Caption(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? "xs" : _ref4$size,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4);

  return ___EmotionJSX(Box, _extends({
    fontSize: size,
    color: "gray.700",
    as: "span",
    lineHeight: 1.2
  }, props));
};